import { routerApp } from '../../app.module';

routerApp.controller('voyageAnalysisReportController', ['$rootScope', '$scope', function($rootScope, $scope) {

    $rootScope.selectedMenu = 'voyage-report';
    $scope.pdf = true;

}]);